// extracted by mini-css-extract-plugin
export default {"zoomModal":"h3-z"};